export default __webpack_public_path__ + "static/media/carouselImage3.96dc34f7.png";